<iframe class="grading-guide"
        width="100%"
        height="{{innerContentHeight}}"
        frameBorder="0"
        overflow="hidden"
        scrolling="no"
        [src]="urlSafe">
</iframe>
